export default __webpack_public_path__ + "static/media/avatar-1.9277ecea.png";